import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Button from '../UI/Button';
import Icon from '../UI/Icon';
import Tooltip from '../UI/Tooltip/Tooltip';

import styles from './NestedPlaylistBox.module.scss';
import makeToggleable from '../../../hocs/makeToggleable';
import MenuList from '../UI/MenuList/MenuList';
import DotsButton from '../UI/DotsButton';
import DropZone from '../DropZone/DropZone';
import ConnectedAddFilesBtn from '../ConnectedAddFilesBtn/ConnectedAddFilesBtn';
import PlaylistContents from '../../../pages/Screens/components/PlaylistContents';

class NestedPlaylistBox extends React.Component {
  renderMenu = () => (
    <MenuList isOpen={this.props.isOpen} right={18} top={18}>
      <MenuList.Item
        title="Choose Playlist"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          this.props.onOpenChoosePlaylistModal();
          this.props.close();
        }}
      />
    </MenuList>
  );

  renderHeader = hasPlaylist => {
    const { title, rootRef, open, playlist, placeholder, isMain } = this.props;

    const renderRight = hasPlaylist && (
      <div className={styles.headerLeft}>
        <ConnectedAddFilesBtn
          size="medium"
          withTip={false}
          modalData={{
            id: playlist.id,
          }}
        />
        <DotsButton
          size={16}
          className={styles.dotsButton}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            open();
          }}
        />
      </div>
    );

    return (
      <div ref={rootRef} className={styles.header}>
        <div className={styles.textContainer}>
          {hasPlaylist && <div className={styles.name}>{title || playlist.name}</div>}
          {placeholder && (
            <div className={styles.placeholderWrapper}>
              <div className={cn(styles.placeholder, hasPlaylist && styles.placeholderSmall)}>{placeholder}</div>
              {isMain && (
                <div className={styles.tipContainer} data-tip="Sound will be played from this playlist">
                  <Icon name="volume" size={16} />
                  <Tooltip className={styles.tooltip} />
                </div>
              )}
            </div>
          )}
        </div>
        {renderRight}
        {this.renderMenu()}
      </div>
    );
  };

  render() {
    const { renderHeader } = this;
    const { playlist, onAcceptDrop, onOpenChoosePlaylistModal, onOpenContentSettingsModal } = this.props;

    const hasPlaylist = Boolean(playlist);

    const renderContent = (
      <>
        {renderHeader(hasPlaylist)}
        <div className={styles.body}>
          {!hasPlaylist && (
            <Button className={styles.choosePlaylistBtn} onClick={onOpenChoosePlaylistModal}>
              Choose Playlist
            </Button>
          )}
          {hasPlaylist && (
            <PlaylistContents
              playlistType="split"
              bordered={false}
              playlistId={playlist.id}
              onEditItem={onOpenContentSettingsModal}
            />
          )}
        </div>
      </>
    );

    if (!hasPlaylist) {
      return <div className={styles.container}>{renderContent}</div>;
    }

    return (
      <DropZone className={styles.container} onAcceptDrop={onAcceptDrop}>
        {() => renderContent}
      </DropZone>
    );
  }
}

NestedPlaylistBox.defaultProps = {
  isMain: false,
  title: null,
};

NestedPlaylistBox.propTypes = {
  isMain: PropTypes.bool,
  name: PropTypes.string,
  title: PropTypes.string,
  playlist: PropTypes.object,
  placeholder: PropTypes.string.isRequired,
  onAcceptDrop: PropTypes.func.isRequired,
  onOpenChoosePlaylistModal: PropTypes.func.isRequired,
  onOpenContentSettingsModal: PropTypes.func.isRequired,
  ...makeToggleable.propTypes,
};

export default makeToggleable(NestedPlaylistBox);
